export { renderDrawerFooter as renderNavDrawerFooter } from '../../Drawer/DrawerFooter';
